"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JupiterClient = void 0;
const web3_js_1 = require("@solana/web3.js");
const node_fetch_1 = __importDefault(require("node-fetch"));
class JupiterClient {
    constructor({ connection }) {
        this.url = 'https://quote-api.jup.ag/v4';
        this.lookupTableCahce = new Map();
        this.connection = connection;
    }
    /**
     * Get routes for a swap
     * @param inputMint the mint of the input token
     * @param outputMint the mint of the output token
     * @param amount the amount of the input token
     * @param slippageBps the slippage tolerance in basis points
     * @param swapMode the swap mode (ExactIn or ExactOut)
     * @param onlyDirectRoutes whether to only return direct routes
     */
    async getRoutes({ inputMint, outputMint, amount, slippageBps = 50, swapMode = 'ExactIn', onlyDirectRoutes = false, }) {
        const params = new URLSearchParams({
            inputMint: inputMint.toString(),
            outputMint: outputMint.toString(),
            amount: amount.toString(),
            slippageBps: slippageBps.toString(),
            swapMode,
            onlyDirectRoutes: onlyDirectRoutes.toString(),
        }).toString();
        const { data: routes } = await (await (0, node_fetch_1.default)(`https://quote-api.jup.ag/v4/quote?${params}`)).json();
        return routes;
    }
    /**
     * Get a swap transaction for a route
     * @param route the route to perform swap
     * @param userPublicKey the signer's wallet public key
     * @param slippageBps the slippage tolerance in basis points
     */
    async getSwapTransaction({ route, userPublicKey, slippageBps = 50, }) {
        const resp = await (await (0, node_fetch_1.default)(`${this.url}/swap`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                route,
                userPublicKey,
                slippageBps,
            }),
        })).json();
        const { swapTransaction } = resp;
        const swapTransactionBuf = Buffer.from(swapTransaction, 'base64');
        return web3_js_1.VersionedTransaction.deserialize(swapTransactionBuf);
    }
    /**
     * Get the transaction message and lookup tables for a transaction
     * @param transaction
     */
    async getTransactionMessageAndLookupTables({ transaction, }) {
        const message = transaction.message;
        const lookupTables = (await Promise.all(message.addressTableLookups.map(async (lookup) => {
            return await this.getLookupTable(lookup.accountKey);
        }))).filter((lookup) => lookup);
        const transactionMessage = web3_js_1.TransactionMessage.decompile(message, {
            addressLookupTableAccounts: lookupTables,
        });
        return {
            transactionMessage,
            lookupTables,
        };
    }
    async getLookupTable(accountKey) {
        if (this.lookupTableCahce.has(accountKey.toString())) {
            return this.lookupTableCahce.get(accountKey.toString());
        }
        return (await this.connection.getAddressLookupTable(accountKey)).value;
    }
    /**
     * Get the jupiter instructions from transaction by filtering out instructions to compute budget and associated token programs
     * @param transactionMessage the transaction message
     * @param inputMint the input mint
     * @param outputMint the output mint
     */
    getJupiterInstructions({ transactionMessage, inputMint, outputMint, }) {
        return transactionMessage.instructions.filter((instruction) => {
            if (instruction.programId.toString() ===
                'ComputeBudget111111111111111111111111111111') {
                return false;
            }
            if (instruction.programId.toString() ===
                'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA') {
                return false;
            }
            if (instruction.programId.toString() === '11111111111111111111111111111111') {
                return false;
            }
            if (instruction.programId.toString() ===
                'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL') {
                const mint = instruction.keys[3].pubkey;
                if (mint.equals(inputMint) || mint.equals(outputMint)) {
                    return false;
                }
            }
            return true;
        });
    }
}
exports.JupiterClient = JupiterClient;
